import gql from "graphql-tag";

export const PRODUCTS_QUERY = gql`
  query products {
    products {
      id
      name
      description
      color
      active
      visible
      sortOrder
      options {
        id
        name
        value
      }
      prices {
        id
        name
        active
        description
        price
        visible
        recurringInterval
        behavior
        trialDays
        installments
        guaranteeDays
      }
    }
  }
`;
